import axios from 'axios'
import { set } from 'vue'

// Initial state factory function
const getDefaultState = () => {
  return {
    data: []
  }
}

export default {
  state: getDefaultState(),
  mutations: {
    SET_WAREHOUSES(state, data) {
      set(state, 'data', data)
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async getWarehousesList({ commit }) {
      const res = await axios.get('/warehouse/list', {
        params: { page: 1, limit: 50, deleted: false }
      })
      commit('SET_WAREHOUSES', res.data.content)
    },
    async onAddWarehouse({ dispatch }, data) {
      const res = await axios.post('/warehouse', data)
      dispatch('getWarehousesList')
      return res.status
    },
    async onEditWarehouse({ dispatch }, { id, data }) {
      const res = await axios.put(`/warehouse/${id}`, data)
      dispatch('getWarehousesList')
      return res.status
    }
  }
}
